import { MaterialMode } from '@/data/context/CourseEditingContext';
import { bookType, MaterialType } from '@/models/Book';

export function mapTypeToMode(type: MaterialType): MaterialMode {
  const map = {
    [MaterialType.SLIDE]: 'slides' as const,
    [MaterialType.TEXT]: 'default' as const,
  };

  return map[type] || 'default';
}

export type bookRoutes = 'books' | 'teacher-books';

export const mapTypeToRoute: Record<bookType, bookRoutes> = {
  STUDENT: 'books',
  TEACHER: 'teacher-books',
};

export const mapRouteToType = (route?: string): bookType => {
  const map: Record<bookRoutes, bookType> = {
    books: 'STUDENT',
    'teacher-books': 'TEACHER',
  };

  return map[route as bookRoutes] || 'STUDENT';
};
